import fetch from 'utils/fetch'

export const changeOperation = params => {
    return fetch({
        url: '/operation/changeuid',
        data: params,
        method: 'POST',
    })
}

export const autoChangeOperation = params => {
    return fetch({
        url: '/operation/autoChangeuid',
        data: params,
        method: 'POST',
    })
}
// 请求子客信息或直客信息
export const getAgencyInfoList = params => {
    return fetch({
        url: '/operation/agency',
        data: params,
        method: 'POST',
    })
}
// 请求服务商信息
export const getAccountInfo = params => {
    return fetch({
        url: '/operation/account',
        data: params,
        method: 'POST',
    })
}
